import * as React from 'react'

import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import { TimesheetReviewsStatsFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { PeriodState } from 'modules/attendance/lib/types'

interface Props {
  reviewsStats: TimesheetReviewsStatsFragment | null
}

const PeriodStatus = ({ reviewsStats }: Props) => {
  const getStatus = () => {
    switch (reviewsStats?.state) {
      case PeriodState.approved:
        return {
          type: Tag.Types.lime,
          title: i18n.t('clock_in.header.states.approved_title'),
          description: i18n.t('clock_in.header.states.approved_description'),
        }

      case PeriodState.pending:
        return {
          type: Tag.Types.champagne,
          title: i18n.t('clock_in.header.states.pending_title'),
          description: i18n.t('clock_in.header.states.pending_description'),
        }

      case PeriodState.in_progress:
        return {
          type: Tag.Types.grey,
          title: i18n.t('clock_in.header.states.in_progress_title'),
          description: i18n.t('clock_in.header.states.in_progress_description'),
        }

      default:
        return {
          type: Tag.Types.grey,
          title: i18n.t('clock_in.header.states.in_progress_title'),
          description: i18n.t('clock_in.header.states.in_progress_description'),
        }
    }
  }

  const { title, description, type } = getStatus()

  return (
    <Box flexDirection="row" gap="s12" alignItems="center" width="full">
      <Text size="200" weight="semibold" caps>
        {i18n.t('common.state')}
      </Text>

      <Tag leftItem="circle" type={type} showCircle>
        {title}
      </Tag>

      <Text.Normal>{description}</Text.Normal>
    </Box>
  )
}

export default PeriodStatus
